// extracted by mini-css-extract-plugin
export default {"sections":"PageConstructor_sections__OnzQV","header":"PageConstructor_header__4KsT5","pagination":"PageConstructor_pagination__okXca"};